export default "__VITE_ASSET__BzOVVQSe__"